/* LG WISHLIST CORE v1. Prototype brouillon, navigateur uniquement.
   Ne lit ni n'écrit les données Wishlist by Square. Authentification serveur non activée. */
(() => {
  'use strict';
  if (window.LGWishlistCore) return;
  const KEY = 'lg-wishlist-lab-items-v1';
  const MAX = 40;
  const HANDLE = /^[a-z0-9][a-z0-9-]*$/;
  const ID = /^\d{1,20}$/;
  const eventName = 'lg:wishlist-lab:changed';

  function valid(item) {
    return item && typeof item.handle === 'string' && HANDLE.test(item.handle) &&
      ID.test(String(item.variant_id || ''));
  }
  function read() {
    try {
      const raw = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(raw)) return [];
      const known = new Set();
      return raw.filter(item => {
        if (!valid(item)) return false;
        const k = item.handle + '|' + String(item.variant_id);
        if (known.has(k)) return false;
        known.add(k);
        return true;
      }).slice(0, MAX);
    } catch(error) { return []; }
  }
  function write(items) {
    try {
      const unique = [], known = new Set();
      for (const item of items) {
        if (!valid(item)) continue;
        const k = item.handle + '|' + String(item.variant_id);
        if (known.has(k)) continue;
        known.add(k);
        unique.push({handle:item.handle,variant_id:String(item.variant_id),
          added_at:item.added_at || new Date().toISOString()});
        if (unique.length >= MAX) break;
      }
      localStorage.setItem(KEY, JSON.stringify(unique));
      window.dispatchEvent(new CustomEvent(eventName,{detail:{count:unique.length}}));
      return true;
    } catch(error) { return false; }
  }
  function has(handle, variantId) {
    return read().some(item => item.handle === handle && String(item.variant_id) === String(variantId));
  }
  function toggle(handle, variantId) {
    if (!HANDLE.test(String(handle)) || !ID.test(String(variantId))) return {ok:false,reason:'invalid'};
    const items=read(), existing=items.findIndex(x=>x.handle===handle && String(x.variant_id)===String(variantId));
    if (existing >= 0) {
      items.splice(existing,1);
      return {ok:write(items),added:false};
    }
    if (items.length >= MAX) return {ok:false,reason:'limit'};
    items.unshift({handle,variant_id:String(variantId),added_at:new Date().toISOString()});
    return {ok:write(items),added:true};
  }
  function currentVariant(button) {
    const id=button.dataset.lgWishlistForm;
    if (id) {
      const form=document.getElementById(id);
      const selected=form?.querySelector('input[name="id"]:not([disabled]),select[name="id"]:not([disabled])');
      if(selected && ID.test(String(selected.value))) return String(selected.value);
    }
    return button.dataset.lgWishlistVariant;
  }
  function synchronizeButtons() {
    document.querySelectorAll('[data-lg-wishlist-heart]').forEach(btn => {
      const handle=btn.dataset.lgWishlistHandle, variant=currentVariant(btn);
      if (!HANDLE.test(handle || '') || !ID.test(String(variant || ''))) return;
      const selected=has(handle,variant), label=selected?'Retirer de ma sélection':'Ajouter à ma sélection';
      btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      btn.setAttribute('aria-label', label);
      btn.title=label;
      const span=btn.querySelector('[data-lg-wishlist-heart-label]');
      if(span && span.textContent !== label) span.textContent=label;
    });
  }
  let toastTimer;
  function notify(message) {
    let node=document.getElementById('lg-wishlist-lab-notice');
    if (!node) {
      node=document.createElement('div');
      node.id='lg-wishlist-lab-notice';
      node.className='lg-wishlist-lab-notice';
      node.setAttribute('role','status');
      node.setAttribute('aria-live','polite');
      document.body.append(node);
    }
    node.textContent=message;
    node.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer=window.setTimeout(()=>node.classList.remove('is-visible'),2600);
  }
  let pending=false;
  function scheduleSync() {
    if (pending) return;
    pending=true;
    requestAnimationFrame(() => { pending=false; synchronizeButtons(); });
  }
  document.addEventListener('click', event => {
    const btn=event.target.closest('button[data-lg-wishlist-heart]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    const result=toggle(btn.dataset.lgWishlistHandle,currentVariant(btn));
    if (!result.ok) {
      const message=result.reason==='limit'?'La sélection est limitée à '+MAX+' produits.':'Impossible d’enregistrer ce favori sur cet appareil.';
      window.dispatchEvent(new CustomEvent('lg:wishlist-lab:error',{detail:{message}}));
      notify(message);
    } else {
      notify(result.added?'Ajouté à la sélection de test':'Retiré de la sélection de test');
    }
    scheduleSync();
  });
  document.addEventListener('change', event => {
    if(event.target.closest('product-rerender') || event.target.closest('product-card')) scheduleSync();
  });
  window.addEventListener('storage', event => {
    if(event.key === KEY || event.key === null) {
      scheduleSync();
      window.dispatchEvent(new CustomEvent(eventName,{detail:{count:read().length,external:true}}));
    }
  });
  window.addEventListener(eventName,scheduleSync);
  document.addEventListener('shopify:section:load',scheduleSync);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scheduleSync,{once:true});
  else scheduleSync();
  let observerTarget=null;
  const observer=new MutationObserver(records=>{
    for(const record of records) {
      if(record.addedNodes.length || record.removedNodes.length) { scheduleSync(); break; }
    }
  });
  function observe() {
    const target=document.querySelector('main') || document.body;
    if(target && target!==observerTarget) {
      observer.disconnect();
      observerTarget=target;
      observer.observe(target,{childList:true,subtree:true});
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',observe,{once:true});
  else observe();
  window.LGWishlistCore={key:KEY,read,write,has,toggle,MAX};
  window.dispatchEvent(new Event('lg:wishlist-lab:ready'));
})();